// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const CalendarPlusIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={22} viewBox="0 0 18 22" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="calendar-plus" fill="none" fillRule="nonzero" stroke="none" strokeWidth={1}><path id="Path" fill="#FFF" d="M16 19H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1" /><path id="Shape" fill="currentColor" d="M2 20q-.825 0-1.413-.587A1.93 1.93 0 0 1 0 18V4q0-.824.587-1.412A1.93 1.93 0 0 1 2 2h1V0h2v2h8V0h2v2h1q.825 0 1.413.588Q18 3.175 18 4v16zm16 0v-9h-2V8H2v10h7v2zM2 6h14V4H2zm13 9h3v2h-3v3h-2v-3h-3v-2h3v-3h2z" /></g></svg>
))
